import * as SC from './styles';
import { Checkbox, ListItemText, MenuItem } from '@mui/material';

import SelectFilter from './components/Select';

import Box from 'v2/components/UI/Box';
import useFilters from './hooks/useFilters';
import {
  SELECT_ORDER,
  SELECT_SPECIES,
  SELECT_STATUS_CYCLES,
  SELECT_STATUS_NUERSERY,
  SELECT_TYPE,
} from './constants';

import { displayCycleInfoDashboard } from 'utils';
import { useCallback } from 'react';
import { is } from 'date-fns/locale';

const Filters: React.FC = () => {
  const {
    nurserySelected,
    statusNursery,
    typeFilterNurseries,
    typeFilterCycles,
    cyclesCode,
    cyclesSelected,
    specie,
    renderValueCycle,
    orderCycles,
    orderNurseries,
    statusCycle,
    isMobile,
    isTablet,

    handleNurseryActive,
    handleNurseryDisable,
    handleStatusNursery,
    handleTypeFilterNurseries,
    handleTypeFilterCycles,
    handleCycle,
    handleChangeSpecie,
    handleChangeOrderCyles,
    handleChangeOrderNurseries,
    handleChangeStatusCycle,
  } = useFilters();

  const renderSelectsCycles = useCallback(() => {
    if (!nurserySelected) {
      return (
        <>
          <SelectFilter
            label="Ciclos"
            labelId="cycle-label"
            selectId="cycle"
            value={renderValueCycle || ''}
            renderValue={() => renderValueCycle}
            onChange={() => null}
            width={isMobile || isTablet ? '100%' : '50%'}
            maxWidth={isMobile || isTablet ? '100%' : 150}
          >
            <Box flexDirection="column">
              {cyclesCode?.map((item) => {
                const selected = cyclesSelected?.some((c) => c.id === item.id);

                return (
                  <Box
                    key={item.cod}
                    padding={'10px 20px'}
                    alignItems="center"
                    background={selected ? '#b7ffbd' : 'transparent'}
                  >
                    <ListItemText
                      primary={displayCycleInfoDashboard({
                        cycleBegin: item.start,
                        cycleCod: item.cod,
                        cycleEnd: item.end,
                      })}
                    />
                    <Checkbox
                      checked={selected}
                      onChange={() => handleCycle(item)}
                    />
                  </Box>
                );
              })}
            </Box>
          </SelectFilter>

          <SelectFilter
            label="Espécies"
            labelId="specie-label"
            selectId="specie"
            value={specie}
            onChange={handleChangeSpecie}
            width={isMobile || isTablet ? '100%' : 130}
            maxWidth={isMobile || isTablet ? '100%' : 'auto'}
          >
            {SELECT_SPECIES.map(({ id, label, value }) => (
              <MenuItem key={id} value={value}>
                {label}
              </MenuItem>
            ))}
          </SelectFilter>
        </>
      );
    }
  }, [nurserySelected, renderValueCycle, cyclesCode, cyclesSelected, specie]);

  const renderSelectStatusNursery = () => {
    return SELECT_STATUS_NUERSERY.map(({ id, label, value }) => (
      <MenuItem key={id} value={value}>
        {label}
      </MenuItem>
    ));
  };

  const renderSelectStatusCycles = () => {
    return SELECT_STATUS_CYCLES.map(({ id, label, value }) => (
      <MenuItem key={id} value={value}>
        {label}
      </MenuItem>
    ));
  };

  const renderSelectStatusNurseyOrCyles = () => {
    if (nurserySelected) {
      return (
        <SelectFilter
          label="Status"
          labelId="status-nursery-label"
          selectId="status"
          value={statusNursery}
          onChange={handleStatusNursery}
          width={isMobile || isTablet ? '100%' : 130}
          maxWidth={isMobile || isTablet ? '100%' : 200}
        >
          {renderSelectStatusNursery()}
        </SelectFilter>
      );
    }
    return (
      <SelectFilter
        label="Status"
        labelId="status-cycle-label"
        selectId="status-cycle"
        value={statusCycle}
        onChange={handleChangeStatusCycle}
        width={isMobile || isTablet ? '100%' : 130}
        maxWidth={isMobile || isTablet ? '100%' : 200}
      >
        {renderSelectStatusCycles()}
      </SelectFilter>
    );
  };

  const renderOrder = () => {
    if (nurserySelected) {
      return (
        <SelectFilter
          label="Ordem dos itens"
          labelId="order-nuersery-label"
          selectId="order-nuersery"
          value={orderNurseries}
          onChange={handleChangeOrderNurseries}
          width={isMobile || isTablet ? '100%' : '50%'}
          maxWidth={isMobile || isTablet ? '100%' : 200}
        >
          {SELECT_ORDER.map(({ id, label, value }) => (
            <MenuItem key={id} value={value}>
              {label}
            </MenuItem>
          ))}
        </SelectFilter>
      );
    }

    return (
      <SelectFilter
        label="Ordem dos itens"
        labelId="order-cycle-label"
        selectId="order-cycle"
        value={orderCycles}
        onChange={handleChangeOrderCyles}
        width={isMobile || isTablet ? '100%' : '50%'}
        maxWidth={isMobile || isTablet ? '100%' : 200}
      >
        {SELECT_ORDER.map(({ id, label, value }) => (
          <MenuItem key={id} value={value}>
            {label}
          </MenuItem>
        ))}
      </SelectFilter>
    );
  };

  const renderTypeFilters = () => {
    if (nurserySelected) {
      return (
        <SelectFilter
          label="Tipo"
          labelId="type-nurseries-label"
          selectId="type-nurseries"
          value={typeFilterNurseries}
          onChange={handleTypeFilterNurseries}
          width={isMobile || isTablet ? '100%' : 'auto'}
          maxWidth={isMobile || isTablet ? '100%' : 'auto'}
        >
          {SELECT_TYPE.map(({ id, label, value }) => (
            <MenuItem key={id} value={value}>
              {label}
            </MenuItem>
          ))}
        </SelectFilter>
      );
    }

    return (
      <SelectFilter
        label="Tipo"
        labelId="type-cycles-label"
        selectId="type-cycles"
        value={typeFilterCycles}
        onChange={handleTypeFilterCycles}
        width={isMobile || isTablet ? '100%' : 'auto'}
        maxWidth={isMobile || isTablet ? '100%' : 'auto'}
      >
        {SELECT_TYPE.map(({ id, label, value }) => (
          <MenuItem key={id} value={value}>
            {label}
          </MenuItem>
        ))}
      </SelectFilter>
    );
  };
  return (
    <Box
      width={'100%'}
      gap={10}
      alignItems="center"
      justifyContent="space-between"
    >
      <Box gap={10} flexWrap="wrap" width={'100%'}>
        <Box
          borderRadius={16}
          alignItems="center"
          width={isMobile || isTablet ? '100%' : 'auto'}
        >
          <SC.ButtonFilter
            onClick={handleNurseryActive}
            variant="left"
            selected={nurserySelected}
            width={isMobile || isTablet ? '100%' : 'auto'}
          >
            Viveiros
          </SC.ButtonFilter>

          <SC.ButtonFilter
            onClick={handleNurseryDisable}
            variant="right"
            selected={!nurserySelected}
            width={isMobile || isTablet ? '100%' : 'auto'}
          >
            Ciclos
          </SC.ButtonFilter>
        </Box>

        <Box width={1} background="#a7a7a7" height={'100%'} />

        <Box gap={10} width={isMobile || isTablet ? '100%' : 'auto'}>
          {renderSelectStatusNurseyOrCyles()}

          {renderTypeFilters()}

          {renderSelectsCycles()}
        </Box>

        <Box width={1} background="#a7a7a7" height={'100%'} />

        {renderOrder()}
      </Box>
    </Box>
  );
};

export default Filters;
